const errorMessages = {
  required: "This field is required!",
  minLength: (len) => `There is a minimum character count of ${len}`,
  validate: "validation error",
};

export default errorMessages;
